import { SingleInputConnectIntegrationFormDrawerContent } from '@modules/integrationsV2/components/AddIntegrationFormDrawerContent/SingleInputConnectIntegrationFormDrawerContent';
import { GetAddIntegrationFormDrawerContentProps } from '@modules/integrationsV2/utils/getAddIntegrationFormDrawerContent';
import { useState } from 'react';

export const EmailFormDrawerContent = ({
  integrationType,
  integrationChannel,
  onDrawerClose,
  integrationID,
}: GetAddIntegrationFormDrawerContentProps) => {
  const [displayName, setDisplayName] = useState('');

  return (
    <SingleInputConnectIntegrationFormDrawerContent
      inputFieldData={displayName}
      setInputFieldData={setDisplayName}
      integrationChannel={integrationChannel}
      integrationType={integrationType}
      integrationData={{
        emailInbound: {
          displayName: displayName,
        },
      }}
      textFieldProps={{
        label: 'Display Name',
        placeholder: 'Enter Display Name',
      }}
      onDrawerClose={onDrawerClose}
    />
  );
};
